import { ISite, ISiteV2 } from "../../interfaces/Site";
import styles from "./GeneratorModal.module.scss";
import { DialogPublic } from "../DialogPublic/DialogPublic";

interface IProps {
    children: any;
    close: () => void;
    open: boolean;
    site: ISite | ISiteV2;
    large?: boolean;
    "data-test-id"?: string;
}

export default function GeneratorModal(props: IProps) {
    return (
        <DialogPublic
            size={props.large ? "LARGE" : "SMALL"}
            open={props.open}
            padding={true}
            handleClose={props.close}
            data-test-id={props["data-test-id"]}
            closableByOutsideClickAndEsc={true}
        >
            <div className={styles.legacyPadding}>
            {props.children}
            </div>
        </DialogPublic>
    );
}
